export function CollapseClose() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill="#000" fillOpacity="0.88" fillRule="evenodd" clipRule="evenodd">
        <path d="M8.493 6.33l1.646 1.646-1.646 1.646a.5.5 0 10.706.707l2-2a.5.5 0 000-.707l-2-2a.5.5 0 00-.706.707z"></path>
        <path d="M13.5 1.333A1.166 1.166 0 0114.667 2.5v11c0 .644-.523 1.167-1.167 1.167h-11A1.167 1.167 0 011.333 13.5v-11A1.167 1.167 0 012.5 1.333h11zm.167 1.167a.167.167 0 00-.167-.167H6v11.334h7.5a.167.167 0 00.167-.167v-11zM5 13.667V2.333H2.5a.167.167 0 00-.167.167v11a.167.167 0 00.167.167H5z"></path>
      </g>
    </svg>
  );
}
